// Progress's registration: the window `board` and Home's Progress item.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('board', { module: () => import('./board.js'), css: 'windows/board/board.css', key: (a, key) => 'board-' + (key || 'mac'), title: () => 'Progress', place: ['home', 'leading'] })
registerHomeItem({ id: 'board', label: 'Progress', symbol: 'checklist', needs: 'paired', section: 'toolbar', order: 70 })
